import styled from 'astroturf/react';

const BareSearchField = styled.div`
  flex: 1 1 auto;
  min-width: 0;

  & > div {
    margin-right: 0;
  }

  & > div > :global(.material-symbols-outlined) {
    display: none;
  }

  & textarea {
    padding-left: 0;
    background: transparent;
    border: 0;
    box-shadow: none;
  }

  & textarea::placeholder {
    color: var(--text-placeholder, #6d6d7d);
  }
`;

export default BareSearchField;
